import {
  api_my_session_path,
  credentials_api_my_session_path,
  receive_webauthn_credential_api_my_session_path,
  send_otp_api_my_session_path
} from "../../routes";
import {del, get, post} from "../http_client";

export const credentials = (email) => get({ url: credentials_api_my_session_path(), params: { email } })
export const destroy = () => del(({ url: api_my_session_path() }));
export const create = (email, otp) => post({url: api_my_session_path(), params: {email, otp}})
export const receiveWebAuthnCredential = webauthn_credential => post({ url: receive_webauthn_credential_api_my_session_path(), params: { webauthn_credential } })
export const sendOTP = email => post({url: send_otp_api_my_session_path(), params: {email}})